export function resourcesSlider() {
    const $slider = $(".resources-slider");
    let sliderNav = "";
    let $current = "";
    let $total = "";
    $slider.each(function () {
        let $this = $(this);
        sliderNav = $this.next(".resources-slider-nav");
        $current = sliderNav.find('.current');
        $total = sliderNav.find('.total');
        $this.slick({
            dots: !!$slider.hasClass("slider-progress"),
            arrows: true,
            appendArrows: sliderNav,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }
            ]
        }).on('init reInit afterChange', function (event, slick, currentSlide) {
            let i = (currentSlide ? currentSlide : 0) + 1;
            $current.text(i);
            $total.text($this.find(".slick-slide:not(.slick-active)").length + 1);
            if (+$total.text() <= 1) {
                sliderNav.hide();
            } else {
                sliderNav.show();
            }
        });
        $total.text($this.find(".slick-slide:not(.slick-active)").length + 1);
        $current.text("1");
        if (+$total.text() <= 1) {
            sliderNav.hide();
        } else {
            sliderNav.show();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/resourcesSlider.js